import styled from 'styled-components';

export const StyledSocialNetworksTab = styled.div`
  .social-network-add {
    margin-bottom: 20px;
  }

  .social-network-logo {
    display: block;
    width: 32px;
    height: 32px;
    object-fit: contain;
  }

  .social-network-actions {
    display: flex;
    gap: 10px;
  }
`;

export const StyledSocialNetworkDrawer = styled.div`
  .ant-form-item {
    max-width: 407px;
  }
`;
